import { Vector2 } from "api/types/sketch"

export function getMouseAtZoom(mouse: Vector2, zoom: number): Vector2 {
    return {
        X: mouse.X / zoom,
        Y: mouse.Y / zoom
    }
}